<template>
  <v-layout>
    <v-flex v-if="!$auth.loading" xs12>
      <v-title v-show="!$auth.isAuthenticated">
        Welcome to Sign On Glass.
      </v-title>
      <v-card>
        <v-card-text>
          <v-flex v-if="$auth.isAuthenticated" xs12>
            <v-layout v-if="hasDealer" row class="px-0">
              <v-flex xs10 md10 lg10>
                <h3>Hello, {{ $auth.user.nickname }}</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs2 md2 lg2 align-content-end>
                <AppNotifications />
              </v-flex>
              <!-- <v-btn
                @click="showNotification=true"
                :color="notificationCount > 0 ? 'red' : 'primary'"
                dark
                v-if="hasDealer"
              >
                Notifications
                <v-icon>notifications</v-icon>
              </v-btn>-->
            </v-layout>
            <v-layout v-else>
              <h2>
                <span class="alert alert-danger">
                  Please wait as we collect your partner details.
                </span>
              </h2>

              <v-progress-circular
                v-if="authorising"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
            <v-flex sm12 md12 lg12>
              <message-alert :component="message"></message-alert>
            </v-flex>
          </v-flex>
          <v-flex sm12>
            <p>The Vonex Channel Partner Portal</p>

            <hr />
            <v-btn
              v-if="!$auth.isAuthenticated"
              name="login"
              color="primary"
              data-cy-login
              @click="login"
            >
              Login
            </v-btn>
            <hr />
            <order-create
              v-if="
                $auth.isAuthenticated &&
                hasDealer &&
                authLevel &&
                authLevel.toLowerCase() !== 'interested'
              "
            ></order-create>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import OrderCreate from '@/components/order-create';
import AppNotifications from '@/components/app-notifications';
import { httpError } from '@/models/httpError';
import { createNamespacedHelpers, mapActions, mapState } from 'vuex';
const {
  mapState: mapOrderState,
  mapGetters: mapOrderGetters,
} = createNamespacedHelpers(`orders`);

import { mapAuthFields } from '../store/modules/orders';

const {
  mapGetters: mapAuthGetters,
  mapActions: mapAuthActions,
} = createNamespacedHelpers(`orders/auth`);

const { mapActions: mapNotificationsActions } = createNamespacedHelpers(
  `orders/notifications`
);

export default {
  name: 'Home',
  components: {
    AppNotifications,
    OrderCreate,
  },
  data() {
    return {
      showNotification: false,
      notificationCount: 0,
      formIsSaved: false,
      authorising: false,
    };
  },
  methods: {
    ...mapAuthActions(['setAuth', 'setMessage']),
    ...mapNotificationsActions(['getNewNotificationCount']),
    ...mapActions('orders', ['getDealerFromEmail']),
    login: function () {
      this.$auth.loginWithRedirect();
    },
    hasNewNotifications() {
      let vm = this;
      if (vm.getNewNotificationCount > 0) return 'red';
      else return 'primary';
    },
  },
  computed: {
    ...mapAuthGetters(['auth']),
    ...mapOrderGetters(['hasDealer', 'hasOrder', 'authLevel', 'authGroup']),
    ...mapState('orders/auth', ['message']),
    loading() {
      return this.$auth.loading;
    },
  },
  watch: {
    loading: async function (newValue, oldValue) {
      let vm = this;
      vm.setMessage(
        new httpError({
          message: '',
          httpStatus: 0,
        })
      );
    },
  },
  mounted() {
    let vm = this;
    this.$store.commit('orders/setIsQuote', false);
    vm.setMessage(
      new httpError({
        message: '',
        httpStatus: 0,
      })
    );
  },
};
</script>
<style scoped>
.btn-primary {
  background: #468f65;
  border: 1px solid #468f65;
}

.card {
  text-decoration: none;
  color: #000;
}
</style>
